export type Tone = 'neutral' | 'progress' | 'success' | 'warning' | 'danger' | 'info' | 'highlight'

export const TONE_CLASS: Record<Tone, string> = {
  neutral: 'border-transparent bg-muted text-muted-foreground',
  progress: 'border-transparent bg-primary/15 text-primary dark:bg-primary/25 dark:text-accent-foreground',
  success: 'border-transparent bg-success/15 text-success',
  warning: 'border-transparent bg-warning/15 text-warning',
  danger: 'border-transparent bg-destructive/15 text-destructive',
  info: 'border-transparent bg-info/15 text-info',
  highlight: 'border-transparent bg-highlight text-highlight-foreground'
}

export const TONE_DOT_CLASS: Record<Tone, string> = {
  neutral: 'bg-muted-foreground/60',
  progress: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-destructive',
  info: 'bg-info',
  highlight: 'bg-highlight-foreground'
}

export const TONE_TEXT_CLASS: Record<Tone, string> = {
  neutral: 'text-muted-foreground',
  progress: 'text-primary',
  success: 'text-success',
  warning: 'text-warning',
  danger: 'text-destructive',
  info: 'text-info',
  highlight: 'text-highlight-foreground'
}

export interface Labeled {
  label: string
  tone: Tone
}
